
<div class="app-body">

<app-header  [menuOpened]="menuOpened" (menuChange)="menuOpened = $event"></app-header>

<div class="main-content">
  <app-menu [menuOpened]="menuOpened"></app-menu>

  <div class="content">
    <ng-content></ng-content>
  </div>
</div>

</div>
